<div mat-dialog-header class="title">
    Add Bench Seam
</div>

<div mat-dialog-content>
    <div class="flex-column">
        <mat-form-field>
            <mat-label>Add Bench Seam</mat-label>
            <div *ngIf="loading">
                <mat-spinner strokeWidth="4" [diameter]="30"></mat-spinner>
            </div>

            <!-- Chips List -->
            <mat-chip-grid #chipGrid aria-label="Enter Bench Seam ...">
                <mat-chip-row *ngFor="let value of benchSeamArray" (removed)="removeValue(value)">
                    {{ value }}
                    <button matChipRemove aria-label="remove bench value">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </mat-chip-grid>

            <!-- Input Field for New Bench Value -->
            <div class="input-unit-flex">
                <input
                    placeholder="Add new bench seam..."
                    [matChipInputFor]="chipGrid"
                    (matChipInputTokenEnd)="addValue($event)"
                    [(ngModel)]="newValue"
                />
            </div>
        </mat-form-field>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!valid()" (click)="save()">Save</button>
</div>
